import { useMemo } from 'react'
import { matchPath, useLocation } from 'react-router-dom'

// TODO: Is there a better way of doing this?
const patterns = [
  '/:story',
  '/:filter/:story',
  '/:filter1?/:filter2?/:story',
  '/:filter1?/:filter2?/:filter3?/:story',
  '/:filter1?/:filter2?/:filter3?/:filter4?/:story',
  '/:filter1?/:filter2?/:filter3?/:filter4?/:filter6?/:story',
  '/:filter1?/:filter2?/:filter3?/:filter4?/:filter6?/:filter7?/:story',
  '/:filter1?/:filter2?/:filter3?/:filter4?/:filter6?/:filter7?/:filter8?/:story',
  '/:filter1?/:filter2?/:filter3?/:filter4?/:filter6?/:filter7?/:filter8?/:filter9?/:story',
]

export function useStoryRoute() {
  const location = useLocation()
  const { pathname } = location

  const { filter, story } = useMemo(() => {
    for (const pattern of patterns) {
      const routerMatch = matchPath(pattern, pathname)

      if (routerMatch) {
        const filter = [
          routerMatch.params.filter,
          routerMatch.params.filter1,
          routerMatch.params.filter2,
          routerMatch.params.filter3,
          routerMatch.params.filter4,
          routerMatch.params.filter5,
          routerMatch.params.filter6,
          routerMatch.params.filter7,
          routerMatch.params.filter8,
          routerMatch.params.filter9,
        ]
          .filter(Boolean)
          .join('/')

        const story = routerMatch.params.story ?? ''

        // if the URL ends with '/' we don't have an active story, only filtered folders
        if (routerMatch.pathname.endsWith('/')) {
          let derivedFilter = `${filter}/${story}`
          if (derivedFilter.startsWith('/')) {
            derivedFilter = derivedFilter.slice(1)
          }

          return {
            filter: derivedFilter,
            story: '',
          }
        }

        return {
          filter,
          story: story.replace(/[\\?].*/, ''),
        }
      }
    }

    return {
      filter: '',
      story: '',
    }
  }, [pathname])

  // console.log({ filter, story })
  return { filter, story }
}
